import React from 'react';
import { Document, BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';
import {
  documentToReactComponents,
  Options,
} from '@contentful/rich-text-react-renderer';
import { Link } from '@theme-ui/components';
import Text from '../components/01_atoms/Text/Text';

const renderOptions: Options = {
  renderMark: {
    [MARKS.BOLD]: (text): JSX.Element => (
      <Text as="span" variant="bold">
        {text}
      </Text>
    ),
  },
  renderNode: {
    [BLOCKS.HEADING_1]: (node, children): JSX.Element => (
      <Text variant="h1" as="h1">
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_2]: (node, children): JSX.Element => (
      <Text variant="h2" as="h2">
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_3]: (node, children): JSX.Element => (
      <Text variant="h3" as="h3">
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_4]: (node, children): JSX.Element => (
      <Text variant="h4" as="h4">
        {children}
      </Text>
    ),
    [BLOCKS.PARAGRAPH]: (node, children): JSX.Element => (
      <Text as="p" sx={{ whiteSpace: 'pre-wrap', marginBottom: 3 }}>
        {children}
      </Text>
    ),
    [INLINES.HYPERLINK]: (node, children): JSX.Element => {
      return (
        <Link href={node?.data?.uri ?? '/'} variant="textnormal" color="black">
          {children}
        </Link>
      );
    },
    // Interface not complete
    [INLINES.ASSET_HYPERLINK]: (node, children): JSX.Element => {
      // File is separated in locales. Just using the first one.
      const data: {
        url: string;
      }[] = Object.values(node?.data?.target?.fields?.file);

      return <Link href={data?.[0]?.url}>{children}</Link>;
    },
  },
};

export interface ReactComponentsByDocumentProps {
  document: Document;
}
const ReactComponentsByDocument: React.FC<ReactComponentsByDocumentProps> = ({
  document,
}: ReactComponentsByDocumentProps) => {
  return <>{documentToReactComponents(document, renderOptions)}</>;
};

export default ReactComponentsByDocument;
